import React from "react";
import { Card, Row, Col } from "antd";
import '../Styles/UserStylings/CategoryList.css'
import { Link } from "react-router-dom";

const CategoryList = ({ categories, onSelectCategory }) => {
  if (!categories || categories.length === 0) return null;

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  return (
    <div className="category-container">
      <Row gutter={[24, 24]}>
        {categories.map((category) => {
          const iconUrl = category.icon
            ? `${BASE_URL}/uploads/categories/${category.icon}`
            : "/default-category.png";

          // **Sample discount data:** (You can remove this if not needed)
          const discountText = category.discount ? `Upto ${category.discount}` : null;

          return (
            // Adjusted Col sizes for a grid similar to the screenshot
            <Col xs={24} sm={12} md={8} lg={8} xl={6} key={category.id}>
              <Link
                to={`/category/${category.id}`}
                onClick={() => onSelectCategory && onSelectCategory(category.id)}
              >
                {/* Ensure the category-card class is used */}
                <Card hoverable className={`category-card ${category.selected ? 'selected' : ''}`}>
                  
                  {/* NEW STRUCTURE: A single container to hold everything horizontally */}
                  <div className="category-content-horizontal">
                    
                    {/* 1. Image Wrapper (Left Side) */}
                    <div className="category-image-wrapper">
                      <img
                        src={iconUrl}
                        alt={category.name}
                        className="category-image"
                      />
                    </div>
                    
                    {/* 2. Text Content (Right Side, Name and Discount) */}
                    <div className="category-text-wrapper">
                      <h3 className="category-name-horizontal">{category.name}</h3>
                      {discountText && (
                        <div className="category-discount">
                          {discountText}
                        </div>
                      )}
                    </div>

                  </div>
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default CategoryList;